import React, { useState } from 'react';
import { api } from '../../api';
import { Plus, Trash2, Save, X, Pencil } from 'lucide-react';

const empty = { nameFr: '', nameEn: '', priceSteel: '', priceTitanium: '', order: 0 };

const PiercingsAdmin = ({ content, refresh }) => {
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const startNew = () => {
    setForm({ ...empty, order: (content.piercings?.length || 0) });
    setEditing('new');
  };
  const startEdit = (p) => {
    setForm({
      nameFr: p.nameFr || '',
      nameEn: p.nameEn || '',
      priceSteel: p.priceSteel || '',
      priceTitanium: p.priceTitanium || '',
      order: p.order || 0,
    });
    setEditing(p.id);
  };
  const cancel = () => { setEditing(null); setForm(empty); };

  const save = async () => {
    const payload = { ...form, img: '', extra: '', price: '' };
    if (editing === 'new') {
      await api.post('/admin/piercings', payload);
    } else {
      await api.put(`/admin/piercings/${editing}`, payload);
    }
    await refresh();
    cancel();
  };

  const del = async (id) => {
    if (!window.confirm('Supprimer ce piercing ?')) return;
    await api.delete(`/admin/piercings/${id}`);
    await refresh();
  };

  const items = (content.piercings || []).slice().sort((a, b) => (a.order || 0) - (b.order || 0));

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="h-display text-[32px]">Tarifs Piercings</h2>
          <p className="text-[13px] text-[#8A8275] mt-1">
            Modifiez la grille tarifaire (acier chirurgical & titane). {items.length} piercings.
          </p>
        </div>
        <button onClick={startNew} className="btn-primary"><Plus size={14} /> Ajouter</button>
      </div>

      {editing && (
        <div className="bg-[#FAF8F4] border border-[#957340] p-6 mb-8">
          <div className="flex items-center justify-between mb-5">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#957340]">
              {editing === 'new' ? 'Nouveau piercing' : 'Modifier'}
            </div>
            <button onClick={cancel} className="text-[#8A8275] hover:text-[#1A1A1A]"><X size={16} /></button>
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            <LField label="Nom (FR)" value={form.nameFr} onChange={(v) => setForm({ ...form, nameFr: v })} />
            <LField label="Nom (EN)" value={form.nameEn} onChange={(v) => setForm({ ...form, nameEn: v })} />
            <LField label="Prix acier chirurgical (ex: 15€)" value={form.priceSteel} onChange={(v) => setForm({ ...form, priceSteel: v })} />
            <LField label="Prix titane (ex: 30€) — laisser vide si non disponible" value={form.priceTitanium} onChange={(v) => setForm({ ...form, priceTitanium: v })} />
            <LField label="Ordre d'affichage" type="number" value={form.order} onChange={(v) => setForm({ ...form, order: parseInt(v) || 0 })} />
          </div>
          <div className="mt-6 flex gap-3">
            <button onClick={save} className="btn-primary"><Save size={14} /> Enregistrer</button>
            <button onClick={cancel} className="btn-ghost">Annuler</button>
          </div>
        </div>
      )}

      {/* Tariff table */}
      <div className="border border-[#E8E2D5] bg-white overflow-hidden">
        <div className="grid grid-cols-12 gap-2 px-4 py-3 bg-[#FAF8F4] border-b border-[#E8E2D5] text-[10px] tracking-[0.28em] uppercase text-[#8A8275]">
          <div className="col-span-1">#</div>
          <div className="col-span-4">Piercing</div>
          <div className="col-span-3 text-center">Acier chirurgical</div>
          <div className="col-span-2 text-center">Titane</div>
          <div className="col-span-2 text-right">Actions</div>
        </div>
        {items.map((p, i) => (
          <div key={p.id} className="grid grid-cols-12 gap-2 items-center px-4 py-3 border-b border-[#E8E2D5]/60 hover:bg-[#FAF8F4]/60 transition-colors">
            <div className="col-span-1 text-[12px] text-[#8A8275]">{i + 1}</div>
            <div className="col-span-4">
              <div className="serif text-[15px] text-[#1A1A1A]">{p.nameFr}</div>
              <div className="text-[11px] text-[#8A8275]">{p.nameEn}</div>
            </div>
            <div className="col-span-3 text-center display text-[15px] text-[#3A3A3A]">{p.priceSteel || '—'}</div>
            <div className="col-span-2 text-center display text-[15px] text-[#957340]">{p.priceTitanium || '—'}</div>
            <div className="col-span-2 flex justify-end gap-1">
              <button onClick={() => startEdit(p)} className="p-2 hover:text-[#957340]" aria-label="edit"><Pencil size={14} /></button>
              <button onClick={() => del(p.id)} className="p-2 hover:text-red-600" aria-label="delete"><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const LField = ({ label, value, onChange, type = 'text' }) => (
  <label className="block">
    <span className="text-[10px] tracking-[0.28em] uppercase text-[#8A8275]">{label}</span>
    <input
      type={type}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      className="mt-2 w-full bg-white border border-[#E8E2D5] focus:border-[#957340] outline-none p-3 text-[14px] transition-colors"
    />
  </label>
);

export default PiercingsAdmin;
